<template>
    <div class="pt-3 pb-5">
        <div class="row">
            <div class="col-12">
                <form
                    ref="submitForm"
                    @submit.prevent="saveForm($data)"
                    enctype="multipart/form-data"
                >
                    <input type="hidden" name="_token" :value="$parent._props.csrf">
                    <div class="form-group">
                        <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#gallery">Zmień zdjęcie główne</button><br>
                        <img v-if="data" :src="data.url" class="mw-100 mh-100 img-thumbnail mt-2" width="250">
                    </div>
                    <div class="form-group">
                        <SunEditor
                            v-if="data"
                            name="content"
                            label="Treść opisu o nas"
                            :value="data.content"
                            :invalid="validMessage ? (validMessage.content ? validMessage.content : null) : null"
                        />
                    </div>

                    <input type="submit" class="btn btn-primary" value="Zapisz">
                </form>
            </div>
        </div>
         <div class="modal fade" ref="modal" id="gallery" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="galleryLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="galleryLabel">Galeria zdjęć</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p v-if="!gallery || gallery.length == 0">Brak zdjęć</p>
                <div class="row m-0 w-100">
                    <div class="col-xl-2 col-lg-4 col-sm-6 text-center" v-for="(item, key) in gallery" :key="key">
                        <div class="position-relative shadow gallery-single">
                            <img :src="item.url" class="mw-100 mh-100 img-thumbnail o-fit" style="height:180px">

                            <div class="gallery-action position-absolute">
                                <button @click.prevent="changeImage(item.id)" class="btn btn-success rounded-circle p-2"><iconSelect /></button>
                            </div>
                        </div>
                        <p>{{item.name}}</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-dismiss="modal">Zamknij</button>
            </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    import InputFile from '../../ui/InputFile';
    import SunEditor from '../../ui/SunEditor';
    import iconSelect from '../../icon/select';

    export default {
        data() {
            return {
                token: this.$parent._props.api_token,
                data: null,
                validMessage: null,
                gallery: null,
            }
        },
        components: {
            InputFile, SunEditor, iconSelect
        },
        methods: {
            saveForm(data){
                let _this = this;
                var form = new FormData();
                let _form = $(this.$refs.submitForm).serializeArray()

                $.each(_form, function () {
                    form.append(this.name, this.value);
                });

                this.$parent._data.loading = true;

                axios
                .post('/content/save', form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    params: {
                        'option': 'about'
                    }
                }).then(response => {
                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    this.fetchData();
                })
                .catch(error => {
                    if (error.response.status == 422){
                        this.validMessage = error.response.data.errors;
                        this.$parent._data.message.error = true;
                        this.$parent._data.message.content = 'Uzupełnij pola prawidłowymi danymi!';

                        $('.loading').animate({
                            opacity: 0,
                        }, 1000, function(){
                            _this.$parent._data.loading = false;
                        })
                    }
                })
            },
            changeImage(id){

                axios
                .get('/api/change/image/' + id, {
                    params: {
                        'option': 'about',
                    }
                }).then(response => {

                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;

                    $(this.$refs.modal).modal('hide');

                    this.fetchData();
                });
            },
            file(el){
                this.form.image = el;
            },
            fetchData(){
                let _this = this;
                this.$parent._data.loading = true;
                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'about',
                    }
                }).then(response => {
                    this.data = response.data.option;
                    this.gallery = response.data.gallery;

                    $('.loading').animate({
                        opacity: 0,
                    }, 1000, function(){
                        _this.$parent._data.loading = false;
                    })
                })
            }
        },
        mounted(){
            axios.defaults.params = {};
            axios.defaults.params['api_token'] = this.token;

            this.fetchData();
        },
    }
</script>
